import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-terms-and-conditions-dialog',
  templateUrl: './terms-and-conditions-dialog.component.html',
  styleUrls: ['./terms-and-conditions-dialog.component.scss']
})
export class TermsAndConditionsDialogComponent {
  mustAcceptTermsAndConditions: boolean = false;

  constructor(private dialogRef: MatDialogRef<TermsAndConditionsDialogComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.mustAcceptTermsAndConditions = data.mustAcceptTermsAndConditions;
    this.mustAcceptTermsAndConditions ? (this.dialogRef.disableClose = true) : null;
  }
}
